import { render, staticRenderFns } from "./FinishedClassPackage.vue?vue&type=template&id=6ed370fa&scoped=true&"
import script from "./FinishedClassPackage.vue?vue&type=script&lang=js&"
export * from "./FinishedClassPackage.vue?vue&type=script&lang=js&"
import style0 from "./FinishedClassPackage.vue?vue&type=style&index=0&id=6ed370fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed370fa",
  null
  
)

export default component.exports